const useAlert = () => {
  const alert = (message: string) => window.alert(message);
  return { alert };
};

export default useAlert;
